module.exports = __webpack_public_path__ + "img/settings/dragndrop.204339.png";